import React, { useEffect } from "react";
import { FaBuilding, FaUpload, FaImage, FaSave } from "react-icons/fa";
import CustomDropdown from "../../common/CustomDropdown";

const Organization = ({
  handleSaveEvent,
  handleFileChange,
  uploadedLogo,
  organizationName,
  setOrganizationName,
  addressLineOne,
  setAddressLineOne,
  addressLineTwo,
  setAddressLineTwo,
  pinCode,
  setPinCode,
  errors,
  imageError,
  country,
  countryList,
  state,
  city,
  setCity,
  setState,
  stateList,
  handleCountrydata,
}) => {
  const handleImageUpload = () => {
    document.getElementById("imageUploadInput").click();
  };

  // Log props for debugging
  useEffect(() => {
    console.log("Organization props:", { organizationName, country, state, city, uploadedLogo, stateList });
  }, [organizationName, country, state, city, uploadedLogo, stateList]);

  // Validate state when stateList changes
  useEffect(() => {
    if (state && stateList.length > 0 && !stateList.find((s) => Number(s.id) === Number(state))) {
      console.log("State ID not found in stateList, resetting state");
      setState('');
    }
  }, [stateList, state, setState]);

  return (
    <div>
      {/* Organization Logo Section */}
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
       
          marginBottom: "24px",
   
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
          <div
            style={{
              width: "32px",
              height: "32px",
              backgroundColor: "#184778",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FaImage size={16} style={{ color: "white" }} />
          </div>
          <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#1f2937", margin: 0 }}>Organization Logo</h3>
        </div>

        <div style={{ display: "flex", alignItems: "flex-start", gap: "20px", flexWrap: "wrap" }}>
          <div style={{ position: "relative" }}>
            <img
              src={uploadedLogo || "https://placehold.co/150x100"}
              width="150"
              height="100"
              style={{
                cursor: "pointer",
                objectFit: "cover",
                border: "2px solid #e5e7eb",
                borderRadius: "12px",
                transition: "all 0.2s ease",
              }}
              alt="Organization Logo"
              onClick={handleImageUpload}
              onMouseEnter={(e) => {
                e.target.style.borderColor = "#184778";
                e.target.style.transform = "scale(1.02)";
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = "#e5e7eb";
                e.target.style.transform = "scale(1)";
              }}
            />
            <div
              onClick={handleImageUpload}
              style={{
                position: "absolute",
                bottom: "-8px",
                right: "-8px",
                width: "32px",
                height: "32px",
                backgroundColor: "#184778",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#0f3a5f";
                e.target.style.transform = "scale(1.1)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#184778";
                e.target.style.transform = "scale(1)";
              }}
            >
              <FaUpload size={14} style={{ color: "white" }} />
            </div>
            <input
              type="file"
              id="imageUploadInput"
              style={{ display: "none" }}
              accept="image/*"
              onChange={handleFileChange("logo")}
            />
          </div>

          <div style={{ flex: 1, minWidth: "300px" }}>
            <div
              style={{
                backgroundColor: "#f8fafc",
                padding: "16px",
                borderRadius: "8px",
                border: "1px solid #e2e8f0",
              }}
            >
              <h4 style={{ fontSize: "14px", fontWeight: "600", color: "#374151", margin: "0 0 8px 0" }}>
                Image Requirements
              </h4>
              <ul style={{ fontSize: "13px", color: "#6b7280", margin: 0, paddingLeft: "16px" }}>
                <li>Format: JPG, PNG, SVG, GIF</li>
                <li>Recommended: 150 × 100 pixels</li>
                <li>Maximum file size: 5MB</li>
                <li>Aspect ratio: 3:2 (landscape)</li>
              </ul>
            </div>
          </div>
        </div>

        {imageError && (
          <div
            style={{
              marginTop: "12px",
              padding: "12px",
              backgroundColor: "#fef2f2",
              border: "1px solid #fecaca",
              borderRadius: "8px",
              color: "#dc2626",
              fontSize: "14px",
            }}
          >
            {imageError}
          </div>
        )}
      </div>

      {/* Organization Details Section */}
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          padding: "24px",
          marginBottom: "24px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          border: "1px solid #f1f5f9",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
          <div
            style={{
              width: "32px",
              height: "32px",
              backgroundColor: "#184778",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FaBuilding size={16} style={{ color: "white" }} />
          </div>
          <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#1f2937", margin: 0 }}>Organization Details</h3>
        </div>

        <div className="row">
          <div className="col-md-12 mb-3">
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "8px", display: "block" }}>
              Organization Name <span style={{ color: "#dc2626" }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              value={organizationName}
              onChange={(e) => setOrganizationName(e.target.value)}
              placeholder="Enter organization name"
              style={{
                padding: "12px 16px",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                fontSize: "14px",
                transition: "all 0.2s ease",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#184778";
                e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
            />
            {errors.organizationName && (
              <p style={{ color: "#dc2626", fontSize: "13px", marginTop: "4px", margin: 0 }}>
                {errors.organizationName}
              </p>
            )}
          </div>

          <div className="col-md-6 mb-3">
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "8px", display: "block" }}>
              Address Line 1
            </label>
            <input
              type="text"
              className="form-control"
              value={addressLineOne}
              onChange={(e) => setAddressLineOne(e.target.value)}
              placeholder="Enter address line 1"
              style={{
                padding: "12px 16px",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                fontSize: "14px",
                transition: "all 0.2s ease",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#184778";
                e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "8px", display: "block" }}>
              Address Line 2
            </label>
            <input
              type="text"
              className="form-control"
              value={addressLineTwo}
              onChange={(e) => setAddressLineTwo(e.target.value)}
              placeholder="Enter address line 2"
              style={{
                padding: "12px 16px",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                fontSize: "14px",
                transition: "all 0.2s ease",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#184778";
                e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "8px", display: "block" }}>
              City
            </label>
            <input
              type="text"
              className="form-control"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              placeholder="Enter city name"
              style={{
                padding: "12px 16px",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                fontSize: "14px",
                transition: "all 0.2s ease",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#184778";
                e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "8px", display: "block" }}>
              Country <span style={{ color: "#dc2626" }}>*</span>
            </label>
            <div style={{ position: "relative" }}>
              <CustomDropdown
                dropdownData={countryList}
                dropdownValue={country}
                setDropdownValue={handleCountrydata}
                name="country name"
                fieldName="country"
                eventType="Update"
              />
            </div>
            {errors.country && (
              <p style={{ color: "#dc2626", fontSize: "13px", marginTop: "4px", margin: 0 }}>
                {errors.country}
              </p>
            )}
          </div>

          <div className="col-md-6 mb-3">
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "8px", display: "block" }}>
              State <span style={{ color: "#dc2626" }}>*</span>
            </label>
            <div style={{ position: "relative" }}>
              <CustomDropdown
                dropdownData={stateList}
                dropdownValue={state}
                setDropdownValue={(value) => setState(value ? parseInt(value) : '')}
                name="state name"
                fieldName="state"
                eventType="Update"
              />
            </div>
            {errors.state && (
              <p style={{ color: "#dc2626", fontSize: "13px", marginTop: "4px", margin: 0 }}>
                {errors.state}
              </p>
            )}
          </div>

          <div className="col-md-6 mb-3">
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "8px", display: "block" }}>
              Zip Code
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter zip code"
              value={pinCode}
              onChange={(e) => setPinCode(e.target.value)}
              style={{
                padding: "12px 16px",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                fontSize: "14px",
                transition: "all 0.2s ease",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#184778";
                e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#d1d5db";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>
        </div>
      </div>

      {/* Save Button Section */}
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          padding: "20px 24px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          border: "1px solid #f1f5f9",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <button
          onClick={() => handleSaveEvent()}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "12px 24px",
            backgroundColor: "#184778",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#0f3a5f";
            e.target.style.transform = "translateY(-1px)";
            e.target.style.boxShadow = "0 4px 12px rgba(24, 71, 120, 0.3)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "#184778";
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "none";
          }}
        >
          <FaSave size={14} />
          Save Organization
        </button>
      </div>
    </div>
  );
};

export default Organization;